import React = require("react");
import { Library } from "..";
import { isActivePath } from "../../../Shared/utils/browser";
import { Link } from "../../custom_components/components/library/link";

const menuLink: Library['menuLink'] = (x, handle) => x.external ? (
  <a
    key={x.key}
    className={`menu__link ${isActivePath(x.relative) ? 'menu__link--active' : ''}`}
    href={x.absolute}
    target="_blank"
    rel="noopener noreferrer"
    onClick={handle}
  >
    {x.title}
  </a>
) : (
  <Link key={x.key} url={x.relative} handle={handle} className={`menu__link ${isActivePath(x.relative) ? 'menu__link--active' : ''}`}>
    {x.title}
  </Link>
)

export default menuLink